<!-- @veltra/icons generated sha256:6c88dba3aa6d734d gen:8 source:src/svg/normal/link.svg -->
<script setup lang="ts">
defineOptions({ name: 'ULink' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m10.124 8.71.008.008c.195.195.51.176.705-.02l1.76-1.759A2.5 2.5 0 0 0 9.06 3.404L7.3 5.164c-.195.195-.214.509-.019.704l.022.021c.195.196.509.177.704-.019l1.76-1.76a1.5 1.5 0 1 1 2.121 2.122l-1.76 1.76a.513.513 0 0 0-.005.718M8.707 6.586l-2.12 2.12a.504.504 0 0 0 .002.71c.19.19.51.193.705-.002l2.12-2.12a.504.504 0 0 0-.002-.71l-.008-.009a.49.49 0 0 0-.697.011M6.232 11.89l1.76-1.76c.195-.195.51-.214.705-.018l.02.02c.196.196.177.51-.018.706l-1.76 1.76A2.5 2.5 0 0 1 3.404 9.06l1.76-1.76c.195-.195.509-.214.704-.019l.021.021a.497.497 0 0 1-.018.705l-1.76 1.76a1.5 1.5 0 1 0 2.121 2.121"
    />
  </svg>
</template>
